import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    align-items: center;
  `,
  button: css`
    &.MuiToggleButton-root {
      border-radius: 10px;
      width: 30px;
      height: 24px;
      border: solid 1px ${colors.prussian400};
      color: ${colors.prussian};
      transition: all 0.2s ease-in-out;
    }

    &.MuiToggleButton-root.Mui-selected {
      background-color: ${colors.jungle} !important;
      color: ${colors.white};
    }

    &.MuiToggleButton-root:focus-visible {
      outline: 2px solid ${colors.focusOutlineColor};
      outline-offset: 2px;
      box-shadow: 0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.focusOutlineColor};
    }

  `,
  icon: css`
    font-size: 18px !important;
  `,
  buttonLeft: css`
    &.MuiToggleButton-root {
      padding: 0px 4px 0px 8px;
    }
  `,
  buttonRight: css`
    &.MuiToggleButton-root {
      padding: 0px 8px 0px 4px;
    }
  `,
};

export default styles;
